// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPackageCheckPromoCodeResponse

export type WidgetPackageCheckPromoCodeApiResponse = {
	code: string;
	discountAmount: number;
	finalAmount: number;
};

export type WidgetPackageCheckPromoCode = {
	code: string;
	discountAmount: number;
	finalAmount: number;
};

export function hydrateWidgetPackageCheckPromoCode(data: WidgetPackageCheckPromoCodeApiResponse): WidgetPackageCheckPromoCode {
	return { ...data };
}